module.exports = __webpack_public_path__ + "static/img/vip_privilege6.0ee5363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege6.png
// module id = GwN/
// module chunks = 0